import React from 'react';

import {
  List,
} from '@mui/material';

import type { DrugJson } from '@/types/domain/drug/entities/drugEntity';

import CustomListItem from '@/components/CustomListItem';
import { toStringDateTimeDisplay } from '@/utils/date';

const DrugInfo: React.FC<{
  /** データ */
  data: DrugJson,
}> = ({ data }) => {
  const {
    drugContent,
    measureDateTime,
  } = data.data;
  return (
    <List>
      <CustomListItem
        name="日時"
        content={toStringDateTimeDisplay(new Date(measureDateTime), true)}
      />
      <CustomListItem
        name="薬内容"
        content={drugContent}
      />
    </List>
  );
};

export default DrugInfo;
